import { render, staticRenderFns } from "./HistoryPieChart.vue?vue&type=template&id=2b41f59e&scoped=true"
import script from "./HistoryPieChart.vue?vue&type=script&lang=js"
export * from "./HistoryPieChart.vue?vue&type=script&lang=js"
import style0 from "./HistoryPieChart.vue?vue&type=style&index=0&id=2b41f59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41f59e",
  null
  
)

export default component.exports